import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem, TableFooter, TableRow, TableCell } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const TargetVsLeadGenerationDateReport = () => {
    const history = useHistory();
    const { brand_id } = useParams();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    // Current month first & last date
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
    );
    const lastDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
    );
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const [fromDate, setFromDate] = useState(formatDate(firstDayOfMonth));
    const [toDate, setToDate] = useState(formatDate(lastDayOfMonth));
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - 10; i--) {
            years.push({ id: i, title: i.toString() });
        }
        return years;
    };
    const [yearOptions] = useState(generateYearOptions());
    const [selectedYear, setSelectedYear] = useState(() => {
        const years = generateYearOptions();
        return years.find(y => y.id === new Date().getFullYear()) || years[0];
    });
    const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [sources, setSources] = useState([]);
    const [selectedSource, setSelectedSource] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/webApi/sources`);

                const data = response.data.data;
                setSources(data.map(item => item.enquiry_from));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleSelectChange = (event) => {
        setSelectedSource(event.target.value);
    };
    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));
                setStateOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatastate();
    }, []);

    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const mappedData = response.data.data.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                setExecutiveOptions(mappedData);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);

    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutiveId(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };
    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };
    const handleYearChange = (event, newValue) => {
        setSelectedYear(newValue);
    };
    const fetchData = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const requestData = {
                view_type: "date",
                brand_id: selectedBrand?.id || Number(brand_id),
                start_date: fromDate,
                end_date: toDate,
                pagination: perPage,
                page: page + 1,
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/target-vs-generated-report`,
                requestData,
                config
            );
            const reportData = response?.data?.data?.data || [];

            const mappedData = reportData.map((item, index) => ({
                sn: index + 1,

                date: item.date,
                brand_id: item.brand_id,
                brand_name: item.brand_name,

                target: item.target || 0,
                organic_generated: item.organic_generated || 0,
                social_generated: item.social_generated || 0,
                total_generated: item.total_generated || 0,
                pending_target: item.pending_target || 0,

                balance: (item.total_generated || 0) - (item.target || 0),

            }));

            setData(mappedData);
            setTotalCount(response.data.data.total);
            setSnackbarMessage(
                response.data.message?.[0] || "Brand month wise report list"
            );
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.code === "ECONNABORTED") {
                setError("Request timeout");
            } else {
                setError("Error fetching data");
            }
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [page, perPage]);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };

    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };

    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    const handleNext = () => {
        setPage(page + 1);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData();
    };

    const clearForm = () => {
        window.location.reload();
        setSearch('');
    };

    const columns = [
        {
            name: "sn",
            label: "SN",
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "date",
            label: "Date",
            options: {
                filter: true,
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "brand_name",
            label: "Brand Name",
            options: {
                filter: false,
                customBodyRender: (value) => (
                    <button
                        className={classes.brandstrip}
                        style={{
                            backgroundColor: getColor(value),
                            color: getColorfont(value),
                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "target",
            label: "Target",
            options: {
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "organic_generated",
            label: "Organic Generated",
            options: {
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "social_generated",
            label: "Social Generated",
            options: {
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "total_generated",
            label: "Total Generated",
            options: {
                setCellProps: () => ({ align: "center" }),
            },
        },
        {
            name: "pending_target",
            label: "Balance",
            options: {
                setCellProps: () => ({ align: "center" }),
                customBodyRender: (value) => (
                    <Typography
                        style={{
                            color: value > 0 ? "#d32f2f" : "#2e7d32",
                            fontWeight: 600,
                        }}
                    >
                        {value}
                    </Typography>
                ),
            },
        },
       
    ];

    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                setOpenSidebar(true);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
    };

    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    return (
        <>
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <Box sx={{ width: '100%' }}>
                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                    Target Vs Lead Generation Date Report
                </Typography>
                <hr className={classes.horizontalline} />
            </Box>
            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />
                        ) : (
                            <Typography className={classes.tabletittle} >
                            </Typography>
                        )
                    }
                    data={memoizedData}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>

                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>

                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >
        </>
    );
};

export default TargetVsLeadGenerationDateReport;